import { PlugZap, Mail } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "components/ui/dialog";
import { Button } from "components/ui/button";

const UnsupportedToolDialog = ({ tool, open, onOpenChange }) => {
  const subject = encodeURIComponent(`Integration request: ${tool ?? ""}`);
  const body = encodeURIComponent(
    `Hi Maybe team,\n\nI'd love to use ${tool ?? "this tool"} inside my Tasks. Can we explore getting it connected?\n\nThanks!`
  );

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[440px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <PlugZap className="h-5 w-5 text-[hsl(var(--task-accent))]" />
            {tool ? `${tool} isn't wired up yet` : "Not wired up yet"}
          </DialogTitle>
          <DialogDescription className="pt-1 leading-relaxed">
            We're adding new integrations every week, and we build bespoke connections for clients all the time.
            Tell us how you'd use {tool ?? "this tool"} and we'll figure out the fastest way to get you connected.
          </DialogDescription>
        </DialogHeader>

        <div className="rounded-lg border border-border bg-muted/40 p-3 text-xs leading-relaxed text-muted-foreground">
          In the meantime, your Task will still run. We'll draft whatever we can without touching {tool ?? "it"}.
        </div>

        <DialogFooter className="gap-2">
          <Button variant="ghost" onClick={() => onOpenChange(false)}>
            Not now
          </Button>
          <Button asChild className="bg-foreground text-background hover:bg-foreground/90">
            <a href={`mailto:hello@maybetech.com?subject=${subject}&body=${body}`}>
              <Mail className="mr-2 h-4 w-4" />
              Let's chat
            </a>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default UnsupportedToolDialog;
